function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
export default ({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M21.75 0H2.25C1.01 0 0 1 0 2.25v19.5C0 22.99 1 24 2.25 24h19.5c1.24 0 2.25-1 2.25-2.25V2.25C24 1.01 23 0 21.75 0z",
  fill: "url(#paint0_linear_310_228)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M7.98 2.86a.37.37 0 01.27-.11h11.13c.1 0 .2.04.27.12.06.06.1.15.1.25s-.04.18-.1.25l-3.3 3.02a.37.37 0 01-.25.11H4.5l3.48-3.64zm.23 14.39c-.1 0-.19.04-.25.1L4.6 20.38a.37.37 0 00-.11.25c0 .1.04.18.1.25.07.08.17.12.27.12H16c.1 0 .18-.04.25-.11l3.5-3.64H8.21zM4.5 10h11.52c.1 0 .18.04.25.11l3.48 3.64H8.23a.36.36 0 01-.25-.11L4.5 10z",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  opacity: ".74",
  d: "M16 13.75h3.75v3.5H16v-3.5zM4.5 6.5h3.75V10H4.5V6.5z",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint0_linear_310_228",
  x1: "12",
  y1: "0",
  x2: "12",
  y2: "24",
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#5CA7DB"
}), /*#__PURE__*/React.createElement("stop", {
  offset: "1",
  stopColor: "#3879BD"
}))));